// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mob-lr-padding0 {
    padding-left: 12px;
    padding-right: 12px;
}
.desk-lr-padding12 {
    padding-left: 12px;
    padding-right: 12px;
}
  
.mob-t-padding0 {
    padding-top: 24px;
}
.mob-t-padding16 {
    padding-top: 0px;
}
.mob-bgwhite-lrpad0 {
    padding: 24px;
}
.desk-lr-padding0 {
    padding-left: 0px;
    padding-right: 0px;
}
.lmar-mob5-desk-12 {
    margin-left: -12px;
}

.title {
    font-size: 16px;
    color: #242424;
    font-weight: normal;
}
.heading {
    font-family: Saira;
    font-size: 16px;
    color: black;
    font-weight: 600;
}
.data {
    font-family: Saira;
    font-size: 14px;
    color: black;
    font-weight: 450;
}

a:hover {
    color: #ffffff;
}


    
@media screen and (max-width: 999px) {
  .mob-lr-padding0 {
      padding-left: 0px;
      padding-right: 0px;
  }
    
  .mob-t-padding0 {
        padding-top: 0px;
  }
  .mob-bgwhite-lrpad0 {
        padding-left: 0px;
        padding-right: 0px;
        background-color: white;
  }
  .desk-lr-padding0 {
        padding-left: 16px;
        padding-right: 16px;
  }
  .desk-lr-padding12 {
        padding-left: 16px;
        padding-right: 16px;
  }
  .mob-t-padding16 {
        padding-top: 16px;
  }
  .lmar-mob5-desk-12 {
        margin-left: 5px;
  }

  .title {
        font-size: 20px;
        color: black;
        font-weight: 500;
  }
  .heading {
        font-family: Saira;
        font-size: 12px;
        color: #6d6e71;
        font-weight: 500;
        margin-bottom: 5px;
  }
  .data {
        font-family: Saira;
        font-size: 16px;
        color: black;
        font-weight: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/policies/policy.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;EACE;MACI,iBAAiB;MACjB,kBAAkB;EACtB;;EAEA;QACM,gBAAgB;EACtB;EACA;QACM,iBAAiB;QACjB,kBAAkB;QAClB,uBAAuB;EAC7B;EACA;QACM,kBAAkB;QAClB,mBAAmB;EACzB;EACA;QACM,kBAAkB;QAClB,mBAAmB;EACzB;EACA;QACM,iBAAiB;EACvB;EACA;QACM,gBAAgB;EACtB;;EAEA;QACM,eAAe;QACf,YAAY;QACZ,gBAAgB;EACtB;EACA;QACM,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,kBAAkB;EACxB;EACA;QACM,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,mBAAmB;EACzB;AACF","sourcesContent":[".mob-lr-padding0 {\n    padding-left: 12px;\n    padding-right: 12px;\n}\n.desk-lr-padding12 {\n    padding-left: 12px;\n    padding-right: 12px;\n}\n  \n.mob-t-padding0 {\n    padding-top: 24px;\n}\n.mob-t-padding16 {\n    padding-top: 0px;\n}\n.mob-bgwhite-lrpad0 {\n    padding: 24px;\n}\n.desk-lr-padding0 {\n    padding-left: 0px;\n    padding-right: 0px;\n}\n.lmar-mob5-desk-12 {\n    margin-left: -12px;\n}\n\n.title {\n    font-size: 16px;\n    color: #242424;\n    font-weight: normal;\n}\n.heading {\n    font-family: Saira;\n    font-size: 16px;\n    color: black;\n    font-weight: 600;\n}\n.data {\n    font-family: Saira;\n    font-size: 14px;\n    color: black;\n    font-weight: 450;\n}\n\na:hover {\n    color: #ffffff;\n}\n\n\n    \n@media screen and (max-width: 999px) {\n  .mob-lr-padding0 {\n      padding-left: 0px;\n      padding-right: 0px;\n  }\n    \n  .mob-t-padding0 {\n        padding-top: 0px;\n  }\n  .mob-bgwhite-lrpad0 {\n        padding-left: 0px;\n        padding-right: 0px;\n        background-color: white;\n  }\n  .desk-lr-padding0 {\n        padding-left: 16px;\n        padding-right: 16px;\n  }\n  .desk-lr-padding12 {\n        padding-left: 16px;\n        padding-right: 16px;\n  }\n  .mob-t-padding16 {\n        padding-top: 16px;\n  }\n  .lmar-mob5-desk-12 {\n        margin-left: 5px;\n  }\n\n  .title {\n        font-size: 20px;\n        color: black;\n        font-weight: 500;\n  }\n  .heading {\n        font-family: Saira;\n        font-size: 12px;\n        color: #6d6e71;\n        font-weight: 500;\n        margin-bottom: 5px;\n  }\n  .data {\n        font-family: Saira;\n        font-size: 16px;\n        color: black;\n        font-weight: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
